import { FEATURES } from '@/config/appConfig';
import type { SuggestedQuery, SuggestedQueryCategory } from '../types/chat.types';

export const SUGGESTED_QUERIES: SuggestedQuery[] = [
  // Action Calls
  { id: 'ac-1', category: 'action_calls', label: 'Prepare a sales summary for Sangrovit in broilers',          template: 'Prepare a sales summary for Sangrovit in broilers' },
  { id: 'ac-2', category: 'action_calls', label: 'Write a commercial introduction email for Active D',         template: 'Write a commercial introduction email for Active D' },
  { id: 'ac-3', category: 'action_calls', label: 'Prepare a document set to attach to a presentation',         template: 'Prepare a document set to attach to a presentation' },
  { id: 'ac-4', category: 'action_calls', label: 'Summarize the key benefits of Sangrovit W for ruminants',    template: 'Summarize the key benefits of Sangrovit W for ruminants' },
  { id: 'ac-5', category: 'action_calls', label: 'Draft talking points for a visit to a poultry integrator',   template: 'Draft talking points for a visit to a poultry integrator' },

  // Frequent Queries (hidden by default — toggle ONBOARDING_SHOW_FREQUENT_QUERIES)
  { id: 'fq-1', category: 'frequent', label: 'Sangrovit studies in broilers',   template: 'Sangrovit studies in broilers' },
  { id: 'fq-2', category: 'frequent', label: 'FCR in laying hens ',              template: 'FCR in laying hens' },
  { id: 'fq-3', category: 'frequent', label: 'Phytobiotics in swine diets',     template: 'Phytobiotics in swine diets' },
  { id: 'fq-4', category: 'frequent', label: 'Sangrovit W dosage in ruminants', template: 'Sangrovit W dosage in ruminants' },

  // Latest Available Studies
  { id: 'ls-1', category: 'latest_studies', label: 'Latest available studies',          template: 'Latest available studies' },
  { id: 'ls-2', category: 'latest_studies', label: 'Recent broiler performance trials', template: 'Recent broiler performance trials' },
  { id: 'ls-3', category: 'latest_studies', label: 'Latest intestinal health trials with Sangrovit',        template: 'Latest intestinal health trials with Sangrovit' },

  // Research — category panel variant
  { id: 'rs-1', category: 'research', label: 'Find trial data on Sangrovit performance in broilers',         template: 'Find trial data on Sangrovit performance in broilers' },
  { id: 'rs-2', category: 'research', label: 'Search for published studies and trial reports on Sangrovit W efficacy in dairy cattle',  template: 'Search for published studies and trial reports on Sangrovit W efficacy in dairy cattle' },

  // Analyze — category panel variant
  { id: 'az-1', category: 'analyze', label: 'Compare Sangrovit vs competitor products in broiler trials',    template: 'Compare Sangrovit vs competitor products in broiler trials' },
  { id: 'az-2', category: 'analyze', label: 'Analyze FCR improvement across different Sangrovit dosages',    template: 'Analyze FCR improvement across different Sangrovit dosages' },

  // Sales Tools — category panel variant
  { id: 'st-1', category: 'sales_tools', label: 'Prepare a sales summary for Sangrovit in broilers',         template: 'Prepare a sales summary for Sangrovit in broilers' },
  { id: 'st-3', category: 'sales_tools', label: 'Draft talking points for a visit to a poultry producer',  template: 'Draft talking points for a visit to a poultry producer' },
];

export const CATEGORY_LABELS: Record<SuggestedQueryCategory, string> = {
  action_calls:   'Get started',
  frequent:       'Frequent Queries',
  latest_studies: 'Latest Available Studies',
  research:       'Research',
  analyze:        'Analyze',
  sales_tools:    'Sales Tools',
};

export function getGroupedQueries(only?: SuggestedQueryCategory[]) {
  const defaultOrder: SuggestedQueryCategory[] = [
    'action_calls',
    ...(FEATURES.ONBOARDING_SHOW_FREQUENT_QUERIES ? (['frequent'] as SuggestedQueryCategory[]) : []),
    'latest_studies',
  ];
  const order = only ?? defaultOrder;

  return order.map((cat) => ({
    category: cat,
    label:    CATEGORY_LABELS[cat],
    queries:  SUGGESTED_QUERIES.filter((q) => q.category === cat),
  }));
}
